export class Configuration {
  public id: string;
  public name: string;
  public type: string;
}
